var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-col",
    { attrs: { span: 8 } },
    [
      _c(
        "q-panel",
        { attrs: { "header-text": this.$qt("blog.searchPanelText") } },
        [
          _c(
            "div",
            { staticClass: "panel-padding" },
            [
              _c(
                "q-input",
                {
                  model: {
                    value: _vm.word,
                    callback: function ($$v) {
                      _vm.word = $$v
                    },
                    expression: "word",
                  },
                },
                [
                  _c(
                    "q-button",
                    {
                      attrs: { slot: "append" },
                      on: { click: _vm.search },
                      slot: "append",
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fas", "search"] },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "q-panel",
        { attrs: { "header-text": this.$qt("blog.categoriesPanelText") } },
        [
          _c(
            "div",
            { staticClass: "panel-padding" },
            [
              _c("q-tree", {
                ref: "allCategories",
                staticClass: "filter-tree",
                attrs: {
                  data: _vm.categories,
                  props: _vm.defaultProps,
                  "default-expand-all": "",
                  "expand-on-click-node": false,
                  "filter-node-method": _vm.filterNode,
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }